import { useState } from 'react';

import IcSearch from '@deliveryhero/pd-cookbook/components/Icons/IcSearch';
import InputAdornment from '@mui/material/InputAdornment';

import { TextField } from 'components/TextField';
import { useDebounceCallback } from 'src/hooks/useDebounceCallback';

import { SearchInputProps, TEST_ID } from './types';

export default function SearchInput({
  onSearch,
  value,
  ...props
}: SearchInputProps) {
  const [query, setQuery] = useState<string>(value || '');

  const debouncedSearch = useDebounceCallback(onSearch);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const _query = e.target.value;
    setQuery(_query);
    debouncedSearch(_query);
  };

  return (
    <TextField
      sx={{ width: 384 }}
      label={'search'}
      showElevatedLabel={false}
      autoFocus
      value={query}
      InputProps={{
        style: { padding: 8 },
        startAdornment: (
          <InputAdornment position="start">
            <IcSearch data-testid={TEST_ID} />
          </InputAdornment>
        )
      }}
      onChange={handleSearch}
      {...props}
    />
  );
}
